import {DataStatus} from 'platform/components';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetCustomerV2Query} from '@dms/api/customer';
import {useSelectInterestContactPersonMutation} from '@dms/api/finance';
import {testIds} from '@dms/routes';
import {ContactPersonSelect, handleApiError} from '@dms/shared';

import {Nullish} from 'shared/web';

type ContactPersonFormProps = {
  interestId: string;
  customerId: string;
  contactPersonId?: string | Nullish;
  isDisabled?: boolean;
};

export function ContactPersonForm(props: ContactPersonFormProps) {
  const {
    data: customer,
    isLoading,
    isError,
  } = useGetCustomerV2Query({customerId: props.customerId});

  const [selectContactPerson] = useSelectInterestContactPersonMutation();

  const handleSelect = (contactPersonId: string) => {
    selectContactPerson({
      id: props.interestId,
      selectInterestContactPersonRequestBody: {
        contactPersonId,
      },
    })
      .unwrap()
      .catch(handleApiError);
  };

  return (
    <DataStatus isLoading={isLoading} isError={isError} isEmpty={isNilOrEmpty(customer)}>
      <ContactPersonSelect
        customerId={props.customerId}
        persons={customer?.contacts ?? []}
        selectedPersonId={props.contactPersonId}
        isDisabled={props.isDisabled}
        onSelect={handleSelect}
        data-testid={testIds.interest.detail('contactPersonSelect')}
      />
    </DataStatus>
  );
}
